import http from "@/apis/http";
import url from "@/config/url";

export default {
  online: {
    getData: (params) => http.post(url.online.search, params),
    getColumns: (params) => http.post(url.online.columns, params),
  },
  notice: {
    getData: (params) => http.post(url.notice.search, params),
    getColumns: (params) => http.post(url.notice.columns, params),
  },
  ip_white: {
    getData: (params) => http.post(url.ip_white.search, params),
    getColumns: (params) => http.post(url.ip_white.columns, params),
    action: (params) => http.post(url.ip_white.action, params),
  },
  assistence: {
    getData: (params) => http.post(url.assistence.search, params),
    getColumns: (params) => http.post(url.assistence.columns, params),
    archive: (params) =>
      http.post(url.assistence.action, { ...params, action: "archive" }),
    remove: (params) =>
      http.post(url.assistence.action, { ...params, action: "remove" }),
    reply: (params) =>
      http.post(url.assistence.action, { ...params, action: "reply" }),
    read: (params) =>
      http.post(url.assistence.action, { ...params, action: "read" }),
  },
  dropdown: {
    getCountryCode: (params) =>
      http.post(url.dropdown, { ...params, action: "countryCode" }),
    getLangList: (params) =>
      http.post(url.dropdown, { ...params, action: "lang" }),
  },
  sms: {
    sendRegisterSMS: (params) => http.post(url.sms, { ...params, action: "r" }),
    sendSMS: (params) => http.post(url.sms, { ...params, action: "f" }),
  },
  login: (params) => http.post(url.app.login, params),
  logout: (params) => http.post(url.app.logout, params),
  fetchRemember: (params) => http.post(url.app.remember, params),
  forgetPwd: (params) => http.post(url.forgetPwd, params),
  changePwd: (params) => http.post(url.changePwd, params),
  getVerificationImage: (params) => http.post(url.verification_image, params),
  validateCellphone: (params) => http.post(url.validateCellphone, params),
  getCustomerServiceIframeUrl:(params) => http.post(url.getCustomerServiceIframeUrl, params),
  lang:(params) => http.post(url.lang, params),
  getThirdPartys: (params) => http.post(url.getThirdPartys, params),
};
